export enum COMPANY_TYPES {
  CLIENTE_FINAL = 0,
  FABRICA_MAQUINARIA = 1,
  CONCESIONARIO = 2,
  VENDEDOR_DISTRIBUIDOR = 3,
  TECNICO = 4,
}

export const CompanyTypesString = {
  [COMPANY_TYPES.CLIENTE_FINAL]: 'Cliente Final',
  [COMPANY_TYPES.FABRICA_MAQUINARIA]: 'Fábrica de Maquinaria',
  [COMPANY_TYPES.CONCESIONARIO]: 'Concesionario',
  [COMPANY_TYPES.VENDEDOR_DISTRIBUIDOR]: 'Vendedor/Distribuidor',
  [COMPANY_TYPES.TECNICO]: 'Técnico',
};
